import { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import AccessDenied from '../components/pages/AccessDenied/AccessDenied';
import { appRoutes } from './routes';
import { canAccessRoute } from './access';

export function RouteAccess({ user, route, children }) {
  const location = useLocation();
  if (route.access === 'guest' && user) return <Navigate to="/" replace />;
  if (route.access === 'authenticated' && !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!canAccessRoute(user, route)) return <AccessDenied />;
  return children;
}

export default function AppRoutes({ user }) {
  return (
    <Suspense
      fallback={
        <Box role="status" aria-label="Ładowanie strony" sx={{ p: 4 }}>
          <CircularProgress />
        </Box>
      }
    >
      <Routes>
        {appRoutes.map((route) => {
          const Component = route.Component;
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <RouteAccess user={user} route={route}>
                  <Component
                    {...(route.roleProp ? { userRole: user?.role } : {})}
                  />
                </RouteAccess>
              }
            />
          );
        })}
      </Routes>
    </Suspense>
  );
}
